
import { Component, Vue } from 'nuxt-property-decorator'
import { SvoiButtonLink } from '@svoi-ui/components/button'
import HeadBanner from '~/components/Banners/HeadBanner.vue'

@Component({
  components: { HeadBanner, SvoiButtonLink }
})
export default class CareerNavigator extends Vue {
  get randomImageHeader() {
    return require(`@/assets/images/pages/salt/salt.png`)
  }

  get aboutImage() {
    return require(`@/assets/images/pages/salt/about.png`)
  }
}
